import { stringifyUrl } from 'src/utils/stringifyUrl';
import MemriseApi from '../../MemriseApi';
import { ScenariosResponse } from './schema';

export default class PublicScenarioApiClass extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/public/scenarios' });
  }

  public async getScenarios(
    languagePairId: number,
    filter: {
      topicIds?: number[];
      tagSlugs?: string[];
    } = {},
  ): Promise<ScenariosResponse> {
    const { topicIds, tagSlugs } = filter;
    return await this.get(
      stringifyUrl(`/`, {
        language_pair_id: languagePairId,
        ...(topicIds?.length ? { topic_ids: topicIds.join(',') } : null),
        ...(tagSlugs?.length ? { tag_slugs: tagSlugs.join(',') } : null),
      }),
    );
  }
}

export const PublicScenarioApi = new PublicScenarioApiClass();
